
// src/helpers/lifecycle.js

import React from 'react'
import runAfterInteractions from './run-after-interactions'

export default function(Component) {
  class LifecycleComponent extends React.PureComponent {
    componentWillMount() {
      this.props.willMount && runAfterInteractions(()=> this.props.willMount(this.props))
    }

    componentWillReceiveProps(nextProps) {
      this.props.willUpdate && this.props.willUpdate(this.props, nextProps)
    }

    componentWillUnmount() {
      this.props.willUnmount && runAfterInteractions(()=> this.props.willUnmount(this.props))
    }

    render() {
      return <Component {...this.props} />
    }
  }

  LifecycleComponent.displayName = `Lifecycle(${Component.displayName})`
  return LifecycleComponent
}



// WEBPACK FOOTER //
// ./src/helpers/lifecycle.js